import {useTooltipsStore} from "@/stores/ToastDataStore.ts";
import ClientCache from "@/utils/login/ClientCache.ts";
import {useToast} from "vue-toastification";
import TooltipMetadata = namaTypes.TooltipMetadata;
import FieldTooltipInfo = namaTypes.FieldTooltipInfo;

export default class TooltipUtils {
  private field?: string;
  private fallBackId?: string;
  private lineNumber: number = -100;
  private static _instance: TooltipUtils;

  static instance() {
    if (!this._instance)
      this._instance = new TooltipUtils();
    return this._instance;
  }

  isShowingForField(field: string, fallBackId: string, lineNumber: number): boolean {
    return field === this.field && fallBackId === this.fallBackId && lineNumber == this.lineNumber;
  }

  displayTooltip(message: string, field: string, fallBackId: string, lineNumber: number) {
    this.field = field;
    this.fallBackId = fallBackId;
    this.lineNumber = lineNumber;
    useTooltipsStore().pushTooltipStr(message);
  }

  hideTooltip() {
    this.field = '';
    this.fallBackId = '';
    this.lineNumber = -100;
    useToast().dismiss("nama-tooltip-toast");
    useTooltipsStore().clearTooltips();
  }

  static fetchFieldTooltip(entityType: string, fieldId: string, fallBackId: string, automaticTooltipsOnly: boolean): FieldTooltipInfo[] | undefined {
    let tooltipMetadata: TooltipMetadata | undefined = ClientCache.getTooltipMetadata();
    let fieldTooltipInfo: FieldTooltipInfo[] = this.fetchFieldTooltipInfo(tooltipMetadata, entityType, fieldId);
    if (fallBackId && !(fieldTooltipInfo && fieldTooltipInfo.length))
      fieldTooltipInfo = this.fetchFieldTooltipInfo(tooltipMetadata, entityType, fallBackId);
    if (!fieldTooltipInfo)
      return;
    if (automaticTooltipsOnly)
      fieldTooltipInfo = fieldTooltipInfo.filter(l => l.automaticTooltip);
    if (!fieldTooltipInfo.length)
      return;
    return fieldTooltipInfo;
  }

  private static fetchFieldTooltipInfo(tooltipMetadata: TooltipMetadata | undefined, entityType: string, field: string): FieldTooltipInfo[] {
    if (!tooltipMetadata)
      return [];
    let fieldTooltips: FieldTooltipInfo[];
    let fieldsTooltipById: Record<any, any> = tooltipMetadata.fieldsTooltips ? tooltipMetadata.fieldsTooltips[entityType + '#' + field] : {};
    fieldTooltips = fieldsTooltipById?.list || [];
    let defaultTooltips: Record<any, any> = tooltipMetadata.defaultTooltips ? tooltipMetadata.defaultTooltips[field] : {};
    let joinedTooltips: FieldTooltipInfo[] = fieldTooltips.concat((defaultTooltips && defaultTooltips.list) ? defaultTooltips.list : []);
    return this.getTooltip(joinedTooltips, tooltipMetadata);
  }

  static getTooltip(joinedTooltips: Record<string, any>[], tooltipMetadata: TooltipMetadata) {
    if (!joinedTooltips || !tooltipMetadata.fieldTooltips || !tooltipMetadata.fieldTooltips.length)
      return [];
    return joinedTooltips.map(r => tooltipMetadata.fieldTooltips![r.index]);
  }
}
